import { useEffect, useState } from 'react';
import { BackBar, Chip, Card, AIOutput, WhatsAppBtn, useCoachStream } from './healthShared';

const DAY_TYPES = ['Normal day', 'OPD', 'OT', 'Night duty', 'Travel', 'Conference'];

export default function MyDay({ preset, onBack }) {
  const [day, setDay] = useState(preset || null);
  const { output, running, run, stop } = useCoachStream();

  const pick = (d) => {
    setDay(d);
    run(`My day today: ${d}. Plan my Food, Movement, Hydration, Caffeine and Sleep & Recovery for this day.`, 'my_day');
  };

  useEffect(() => {
    if (preset) pick(preset);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div data-testid="my-day-section">
      <BackBar title="My Day" onBack={onBack} />
      <p className="text-sm text-[#66735F] mb-4 -mt-2">Tell us your day. Get a plan that fits it.</p>
      <div className="flex flex-wrap gap-2 mb-5">
        {DAY_TYPES.map((d) => (
          <Chip key={d} active={day === d} onClick={() => pick(d)} testId={`myday-chip-${d.toLowerCase().replace(/\s/g, '-')}`}>{d}</Chip>
        ))}
      </div>
      {(output || running) && (
        <Card className="p-5" testId="myday-output-card">
          <div className="flex items-center justify-between mb-2">
            <p className="text-xs font-black tracking-widest uppercase text-[#D97B5A]">{day} plan</p>
            {running && <button onClick={stop} data-testid="myday-stop-btn" className="text-xs font-bold text-[#A85A3E]">Stop</button>}
          </div>
          {running && !output && <p className="text-sm text-[#9AA594] animate-pulse">Planning your {day?.toLowerCase()}…</p>}
          <AIOutput text={output} testId="myday-output" />
          {!running && output && <div className="mt-4"><WhatsAppBtn text={output} testId="myday-whatsapp-btn" /></div>}
        </Card>
      )}
      {!output && !running && (
        <Card className="p-8 text-center">
          <p className="text-3xl mb-2">🗓️</p>
          <p className="text-sm text-[#66735F]">Select your day type above and get instant recommendations for food, movement, hydration, caffeine and recovery.</p>
        </Card>
      )}
    </div>
  );
}
